
<template>
  <div class="newsitem">
    <div class="box" @click="goDetail(row.id)">
      <div
        class="jumbimg"
        :style="{ backgroundImage: 'url(' + row.imageUrl + ')' }"
      ></div>
      <div class="info">
        <div class="time">{{ fmtTime }}</div>
        <div class="title">{{ row.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    fmtTime() {
      var t = this.row.createTime;
      if (t) {
        return dayjs(t).format("YYYY年M月D日");
      }
    },
  },
  methods: {
    goDetail(id) {
      if (id) {
        this.$router.push({
          path: `/news/detail/${id}`
        })
      }
    }
  }
};
</script>
<style lang="less">
.newsitem {
  width: 356px;
  background: #ffffff;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  .jumbimg {
    height: 170px;
    background: #e6e6e6;
    display: flex;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .info {
    height: 120px;
    padding: 18px 15px;
    box-sizing: border-box;
    .time {
      margin-bottom: 15px;
      color: #2284f6;
      font-size: 14px;
    }
    .title {
      font-size: 14px;
      line-height: 20px;
      color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/news/newsItem.vue